import { get } from 'lodash'

export default function(fields = {}) {
  return {
    ...fields,
    person: {
      ...fields.person,
      note: get(fields, 'note')
    },
    formPrefix: 'person.',
    minAgeConfirmation: get(fields, 'person.minAgeValue') ? true : false
  }
}
